import { ACCESS, DEFAULT_TABLE_QUERY } from '@/constants/default-variables'

export const ROUTE_NAMES = {
	// ---SECTION DASHBOARD--- //
	PAGE_DASHBOARD: {
		path: '/',
		routeName: '/',
		label: 'dashboard',
		role: ACCESS.All,
		component: () => import('@/pages/PageDashboard/index.vue'),
		iconName: 'dashboard',
	},
	// ---SECTION USERS--- //
	PAGE_USERS: {
		path: '/users',
		routeName: 'PAGE_USERS',
		label: 'usersPage',
		role: ACCESS.AdminSysop,
		iconName: 'users',
	},
	// SUBSECTION IN USER SECTION
	LIST_PLAYERS: {
		path: `players-list`,
		routeName: 'LIST_PLAYERS',
		label: 'listPlayers',
		role: ACCESS.AdminSysop,
		component: () => import('@/pages/PageUsers/lists/ListPlayers/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
			search: null,
			country: null,
			currency: null,
		},
	},
	LIST_LOGOUT_PLAYERS: {
		path: 'logout-players',
		routeName: 'LIST_LOGOUT_PLAYERS',
		label: 'listLogoutPlayers',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageUsers/lists/ListLogoutPlayer/index.vue'),
		table: true,
	},
	LIST_STAFF: {
		path: 'staff-list',
		routeName: 'LIST_STAFF',
		label: 'listStaffs',
		role: ACCESS.AdminSysop,
		component: () => import('@/pages/PageUsers/lists/ListStaff/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_HALLS: {
		path: 'halls-list',
		routeName: 'LIST_HALLS',
		label: 'halls',
		role: ACCESS.AdminSysop,
		component: () => import('@/pages/PageUsers/lists/ListHalls/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_PROMO_CODES_FOR_HALLS: {
		path: 'promo-codes-for-halls',
		routeName: 'LIST_PROMO_CODES_FOR_HALLS',
		label: 'promoCodesForHalls',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageUsers/lists/ListPromoCodesForHalls/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	// DETAIL USER PAGE
	DETAIL_PLAYER: {
		path: 'players-list/:id',
		routeName: 'DETAIL_PLAYER',
		label: 'player',
		role: ACCESS.AdminSysop,
		component: () => import('@/pages/PageUsers/detail/DetailPlayer/index.vue'),
		iconName: 'user',
	},
	DETAIL_PLAYER_INFO: {
		path: 'info',
		routeName: 'DETAIL_PLAYER_INFO',
		label: 'info',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerInfo/index.vue'
			),
	},
	DETAIL_PLAYER_WALLETS: {
		path: 'wallets',
		routeName: 'DETAIL_PLAYER_WALLETS',
		label: 'wallets',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerWallets/index.vue'
			),
	},
	DETAIL_PLAYER_PAYMENTS: {
		path: 'payments',
		routeName: 'DETAIL_PLAYER_PAYMENTS',
		label: 'payments',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerPayments/index.vue'
			),
	},
	DETAIL_PLAYER_TRANSACTIONS: {
		path: 'transactions',
		routeName: 'DETAIL_PLAYER_TRANSACTIONS',
		label: 'transactions',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerTransactions/index.vue'
			),
	},
	DETAIL_PLAYER_WITHDRAWALS_REQUESTS: {
		path: 'withdrawal-requests',
		routeName: 'DETAIL_PLAYER_WITHDRAWALS_REQUESTS',
		label: 'withdrawalRequests',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerWithdrawalsRequests/index.vue'
			),
	},
	DETAIL_PLAYER_WITHDRAWALS: {
		path: 'withdrawals',
		routeName: 'DETAIL_PLAYER_WITHDRAWALS',
		label: 'withdrawals',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerWithdrawals/index.vue'
			),
	},
	DETAIL_PLAYER_DEPOSITS: {
		path: 'deposits',
		routeName: 'DETAIL_PLAYER_DEPOSITS',
		label: 'deposits',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerDeposits/index.vue'
			),
	},
	DETAIL_PLAYER_DEPOSIT_REQUESTS: {
		path: 'deposit-requests',
		routeName: 'DETAIL_PLAYER_DEPOSIT_REQUESTS',
		label: 'depositRequests',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerDepositRequests/index.vue'
			),
	},
	DETAIL_PLAYER_GAMING_SESSIONS: {
		path: 'gaming-sessions',
		routeName: 'DETAIL_PLAYER_GAMING_SESSIONS',
		label: 'gamingSessions',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerGamingSessions/index.vue'
			),
	},
	DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS: {
		path: 'transactions-by-sessions/:sessionId',
		routeName: 'DETAIL_PLAYER_TRANSACTIONS_BY_SESSIONS',
		label: 'gamingSessions',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerTransactionsBySessions/index.vue'
			),
	},
	DETAIL_PLAYER_BONUSES: {
		path: 'bonuses',
		routeName: 'DETAIL_PLAYER_BONUSES',
		label: 'bonuses',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerBonuses/index.vue'
			),
	},
	DETAIL_PLAYER_FILES: {
		path: 'player-files',
		routeName: 'DETAIL_PLAYER_FILES',
		label: 'files',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerFiles/index.vue'
			),
	},
	DETAIL_PLAYER_REQUISITES: {
		path: 'player-requisites',
		routeName: 'DETAIL_PLAYER_REQUISITES',
		label: 'requisites',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerRequisites/index.vue'
			),
	},
	DETAIL_PLAYER_ACCOUNT: {
		path: 'player-accounts',
		routeName: 'DETAIL_PLAYER_ACCOUNT',
		label: 'accounts',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailPlayer/DetailPlayerAccounts/index.vue'
			),
	},
	// DETAIL STAFF PAGE
	DETAIL_STAFF: {
		path: 'staff-list/:id',
		routeName: 'DETAIL_STAFF',
		label: 'staff',
		role: ACCESS.AdminSysop,
		iconName: 'user',
		component: () => import('@/pages/PageUsers/detail/DetailStaff/index.vue'),
	},
	// DETAIL HALL PAGE
	DETAIL_HALL: {
		path: 'halls-list/:id',
		routeName: 'DETAIL_HALL',
		label: 'hall',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () => import('@/pages/PageUsers/detail/DetailHall/index.vue'),
	},
	DETAIL_HALL_INFO: {
		path: 'info',
		routeName: 'DETAIL_HALL_INFO',
		label: 'info',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import('@/pages/PageUsers/detail/DetailHall/DetailHallInfo/index.vue'),
	},
	DETAIL_HALL_PLAYERS: {
		path: 'players',
		routeName: 'DETAIL_HALL_PLAYERS',
		label: 'listPlayers',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import('@/pages/PageUsers/detail/DetailHall/DetailHallPlayers/index.vue'),
	},
	DETAIL_HALL_GROUP_PLAYERS: {
		path: 'players-group',
		routeName: 'DETAIL_HALL_GROUP_PLAYERS',
		label: 'listGroupPlayers',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailHall/DetailHallGroupPlayers/index.vue'
			),
	},
	DETAIL_HALL_GROUP_SHIFTS: {
		path: 'shifts-history',
		routeName: 'DETAIL_HALL_GROUP_SHIFTS',
		label: 'listGroupShifts',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailHall/DetailHallGroupShifts/index.vue'
			),
	},
	DETAIL_HALL_REPORTS: {
		path: 'hall-reports',
		routeName: 'DETAIL_HALL_REPORTS',
		label: 'listReports',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import('@/pages/PageUsers/detail/DetailHall/DetailHallReports.vue'),
	},
	DETAIL_REPORT: {
		path: 'hall-reports/:reportId',
		routeName: 'DETAIL_REPORT',
		label: 'report',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () => import('@/pages/PageUsers/detail/DetailReport/index.vue'),
	},
	DETAIL_REPORT_INFO: {
		path: 'report-info',
		routeName: 'DETAIL_REPORT_INFO',
		label: 'info',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import('@/pages/PageUsers/detail/DetailReport/DetailReportInfo.vue'),
	},
	DETAIL_REPORT_PLAYERS: {
		path: 'report-players',
		routeName: 'DETAIL_REPORT_PLAYERS',
		label: 'reportPlayers',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import('@/pages/PageUsers/detail/DetailReport/DetailReportPlayers.vue'),
	},
	DETAIL_REPORT_TOTALS: {
		path: 'report-totals',
		routeName: 'DETAIL_REPORT_TOTALS',
		label: 'reportTotals',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import('@/pages/PageUsers/detail/DetailReport/DetailReportTotals.vue'),
	},

	// ---SECTION SHIFTS--- //
	DETAIL_SHIFT: {
		path: 'shift/:id',
		routeName: 'DETAIL_SHIFT',
		label: 'shift',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () => import('@/pages/PageUsers/detail/DetailShift/index.vue'),
	},
	DETAIL_SHIFT_INFO: {
		path: 'info',
		routeName: 'DETAIL_SHIFT_INFO',
		label: 'info',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import('@/pages/PageUsers/detail/DetailShift/DetailShiftInfo/index.vue'),
	},
	DETAIL_SHIFT_ACCOUNTS: {
		path: 'accounts',
		routeName: 'DETAIL_SHIFT_ACCOUNTS',
		label: 'accounts',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailShift/DetailShiftAccounts/index.vue'
			),
	},
	DETAIL_SHIFT_OPERATIONS: {
		path: 'operations',
		routeName: 'DETAIL_SHIFT_OPERATIONS',
		label: 'operations',
		role: ACCESS.AdminSysop,
		iconName: 'halls',
		component: () =>
			import(
				'@/pages/PageUsers/detail/DetailShift/DetailShiftOperations/index.vue'
			),
	},

	// ---SECTION GAMES--- //
	PAGE_GAMES: {
		path: '/games',
		routeName: 'GAMES_PAGE',
		label: 'gamesPage',
		role: ACCESS.AdminSysopManager,
		iconName: 'game-controller',
	},
	// SUBSECTION IN GAMES SECTION
	LIST_GAMES: {
		path: 'games-list',
		routeName: 'LIST_GAMES',
		label: 'listGames',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageGames/lists/ListGames/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_CATEGORIES: {
		path: 'categories-list',
		routeName: 'LIST_CATEGORIES',
		label: 'listCategories',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageGames/lists/ListCategories/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_TAGS: {
		path: 'tags-list',
		routeName: 'LIST_TAGS',
		label: 'listTags',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageGames/lists/ListTags/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_PROVIDERS_INTEGRATIONS: {
		path: 'integrations-list',
		routeName: 'LIST_PROVIDERS_INTEGRATIONS',
		label: 'listProvidersIntegrations',
		role: ACCESS.SysopManager,
		component: () =>
			import('@/pages/PageGames/lists/ListProvidersIntegrations/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_MAINTENANCES: {
		path: 'maintenances-list',
		routeName: 'LIST_MAINTENANCES',
		label: 'listMaintenances',
		role: ACCESS.SysopManager,
		component: () =>
			import('@/pages/PageGames/lists/ListMaintenances/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_TRANSACTIONS_BY_INTEGRATIONS: {
		path: 'transactions-by-integrations',
		routeName: 'LIST_TRANSACTIONS_BY_INTEGRATIONS',
		label: 'transactionsByIntegrations',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import(
				'@/pages/PageGames/lists/ListTransactionsByIntegrations/index.vue'
			),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	// DETAIL GAME PAGE
	DETAIL_GAME: {
		path: 'games-list/:id',
		routeName: 'DETAIL_GAME',
		label: 'game',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageGames/detail/DetailGame/index.vue'),
	},
	DETAIL_GAME_INFO: {
		path: 'info',
		routeName: 'DETAIL_GAME_INFO',
		label: 'info',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import('@/pages/PageGames/detail/DetailGame/DetailGameInfo/index.vue'),
	},
	DETAIL_GAME_METRIC: {
		path: 'metrics',
		routeName: 'DETAIL_GAME_METRIC',
		label: 'metrics',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import('@/pages/PageGames/detail/DetailGame/DetailGameMetric/index.vue'),
	},
	// DETAIL CATEGORY PAGE
	DETAIL_CATEGORY: {
		path: 'categories-list/:id',
		routeName: 'DETAIL_CATEGORY',
		label: 'category',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import('@/pages/PageGames/detail/DetailCategory/index.vue'),
	},
	DETAIL_CATEGORY_INFO: {
		path: 'info',
		routeName: 'DETAIL_CATEGORY_INFO',
		label: 'info',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailCategory/DetailCategoryInfo/index.vue'
			),
	},
	DETAIL_CATEGORY_GAMES_LIST: {
		path: 'games',
		routeName: 'DETAIL_CATEGORY_GAMES_LIST',
		label: 'gameInCategory',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailCategory/DetailCategoryGamesList/index.vue'
			),
	},
	DETAIL_CATEGORY_EDIT_GAMES_LIST: {
		path: 'edit-game-list',
		routeName: 'DETAIL_CATEGORY_EDIT_GAMES_LIST',
		label: 'editGamesList',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailCategory/DetailCategoryEditGamesList/index.vue'
			),
	},
	// DETAIL TAG PAGE
	DETAIL_TAG: {
		path: 'tags-list/:id',
		routeName: 'DETAIL_TAG',
		label: 'tag',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageGames/detail/DetailTag/index.vue'),
	},
	DETAIL_TAG_INFO: {
		path: 'info',
		routeName: 'DETAIL_TAG_INFO',
		label: 'info',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import('@/pages/PageGames/detail/DetailTag/DetailTagInfo/index.vue'),
	},
	DETAIL_TAG_EDIT_GAMES_LIST: {
		path: 'edit-games-list',
		routeName: 'DETAIL_TAG_EDIT_GAMES_LIST',
		label: 'editGamesList',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailTag/DetailTagEditGamesList/index.vue'
			),
	},
	// DETAIL PROVIDER INTEGRATION PAGE
	DETAIL_PROVIDER_INTEGRATION: {
		path: 'integrations-list/:id',
		routeName: 'DETAIL_PROVIDER_INTEGRATION',
		label: 'integration',
		role: ACCESS.SysopManager,
		component: () =>
			import('@/pages/PageGames/detail/DetailProviderIntegration/index.vue'),
	},
	DETAIL_INTEGRATION_ARTIFACT: {
		path: 'integrations-list/:id/:artifactId',
		routeName: 'DETAIL_INTEGRATION_ARTIFACT',
		label: 'integrationArtifact',
		role: ACCESS.SysopManager,
		component: () =>
			import('@/pages/PageGames/detail/DetailIntegrationArtifact/index.vue'),
	},
	DETAIL_INTEGRATION_ARTIFACT_APPEARED: {
		path: 'appeared',
		routeName: 'DETAIL_INTEGRATION_ARTIFACT_APPEARED',
		label: 'appearedGames',
		role: ACCESS.SysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailIntegrationArtifact/DetailIntegrationArtifactAppeared/index.vue'
			),
	},
	DETAIL_INTEGRATION_ARTIFACT_DISAPPEARED: {
		path: 'disappeared',
		routeName: 'DETAIL_INTEGRATION_ARTIFACT_DISAPPEARED',
		label: 'disappearedGames',
		role: ACCESS.SysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailIntegrationArtifact/DetailIntegrationArtifactDisappeared/index.vue'
			),
	},
	DETAIL_INTEGRATION_ARTIFACT_CHANGED: {
		path: 'changed',
		routeName: 'DETAIL_INTEGRATION_ARTIFACT_CHANGED',
		label: 'changedGames',
		role: ACCESS.SysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailIntegrationArtifact/DetailIntegrationArtifactChanged/index.vue'
			),
	},
	// DETAIL MAINTENANCE PAGE
	DETAIL_MAINTENANCE: {
		path: 'maintenances-list/:id',
		routeName: 'DETAIL_MAINTENANCE',
		label: 'maintenance',
		role: ACCESS.SysopManager,
		iconName: 'settings',
	},
	DETAIL_MAINTENANCE_GAMES: {
		path: 'games',
		routeName: 'DETAIL_MAINTENANCE_GAMES',
		label: 'gamesMaintenance',
		role: ACCESS.SysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailMaintenance/DetailMaintenanceGames/index.vue'
			),
	},
	DETAIL_MAINTENANCE_PROVIDERS: {
		path: 'providers',
		routeName: 'DETAIL_MAINTENANCE_PROVIDERS',
		label: 'providersMaintenance',
		role: ACCESS.SysopManager,
		component: () =>
			import(
				'@/pages/PageGames/detail/DetailMaintenance/DetailMaintenanceProviders/index.vue'
			),
	},

	// ---SECTION PAYMENT SYSTEM--- //
	PAGE_PAYMENT_SYSTEMS: {
		path: '/payment-systems',
		routeName: 'PAGE_PAYMENT_SYSTEMS',
		label: 'paymentSystems',
		role: ACCESS.AdminSysopSupport,
		iconName: 'bills',
	},
	// SUBSECTION IN PAYMENT SYSTEM SECTION
	LIST_PAYMENTS_SYSTEMS: {
		path: 'payments-systems',
		routeName: 'LIST_PAYMENTS_SYSTEMS',
		label: 'paymentSystemsList',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PagePaymentSystem/lists/ListPaymentsSystems/index.vue'),
	},
	LIST_PAYMENTS_METHODS_WITHDRAWALS: {
		path: 'payments-methods-withdrawals',
		routeName: 'LIST_PAYMENTS_METHODS_WITHDRAWALS',
		label: 'paymentsMethodsWithdrawalsList',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import(
				'@/pages/PagePaymentSystem/lists/ListPaymentsMethodsWithdrawals/index.vue'
			),
	},
	LIST_PAYMENTS_METHODS_DEPOSITS: {
		path: 'payments-methods-deposits',
		routeName: 'LIST_PAYMENTS_METHODS_DEPOSITS',
		label: 'paymentsMethodsDepositsList',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import(
				'@/pages/PagePaymentSystem/lists/ListPaymentsMethodsDeposits/index.vue'
			),
	},
	// DETAIL PAYMENT-SYSTEM PAGE
	DETAIL_PAYMENT_SYSTEM: {
		path: 'payment-systems-list/:id',
		routeName: 'DETAIL_PAYMENT_SYSTEM',
		label: 'paymentSystem',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PagePaymentSystem/detail/DetailPaymentSystem/index.vue'),
	},

	// ---SECTION PAYMENTS--- //
	PAGE_PAYMENTS: {
		path: '/payments',
		routeName: 'PAGE_PAYMENTS',
		label: 'payments',
		role: ACCESS.AdminSysopSupport,
		iconName: 'dollar',
	},
	// SUBSECTION IN PAYMENTS SECTION
	LIST_DEPOSIT_REQUESTS: {
		path: 'deposit-requests-list',
		routeName: 'LIST_DEPOSIT_REQUESTS',
		label: 'depositRequests',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PagePayments/lists/ListDepositRequests/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_DEPOSITS: {
		path: 'deposits-list',
		routeName: 'LIST_DEPOSITS',
		label: 'deposits',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PagePayments/lists/ListDeposits/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_WITHDRAWALS_REQUESTS: {
		path: 'withdrawal-requests-list',
		routeName: 'LIST_WITHDRAWALS_REQUESTS',
		label: 'withdrawalRequests',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PagePayments/lists/ListWithdrawalsRequests/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_WITHDRAWALS: {
		path: 'withdrawals-list',
		routeName: 'LIST_WITHDRAWALS',
		label: 'withdrawals',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PagePayments/lists/ListWithdrawals/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	// DETAIL WITHDRAWAL INVOICE PAGE
	DETAIL_WITHDRAWAL_INVOICE: {
		path: 'withdrawals-requests-list/:id',
		routeName: 'DETAIL_WITHDRAWAL_INVOICE',
		label: 'invoice',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PagePayments/detail/DetailWithdrawalsInvoice/index.vue'),
	},

	// ---SECTION REFERRAL--- //
	PAGE_REFERRAL: {
		path: '/promo-codes',
		routeName: 'PAGE_REFERRAL',
		label: 'promoCodes',
		role: ACCESS.AdminSysopSupport,
		iconName: 'referral',
	},
	// SUBSECTION IN REFERRAL SECTION
	LIST_REFERRAL: {
		path: 'promo-codes-list',
		routeName: 'LIST_REFERRAL',
		label: 'promoCodesList',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PageReferral/lists/ListReferral/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	// DETAIL REFERRAL PAGE
	DETAIL_REFERRAL: {
		path: 'referral-list/:id',
		routeName: 'DETAIL_REFERRAL',
		label: 'promoCode',
		role: ACCESS.AdminSysopSupport,
		component: () =>
			import('@/pages/PageReferral/detail/DetailReferral/index.vue'),
	},

	// ---SECTION PARTNERS--- //
	PAGE_PARTNERS_PROGRAM: {
		path: '/partners-programs',
		routeName: 'PAGE_PARTNERS_PROGRAM',
		label: 'partnersPrograms',
		role: ACCESS.AdminSysop,
		iconName: 'partners',
	},
	// SUBSECTION IN PARTNERS SECTION
	LIST_PARTNERS_PROGRAM: {
		path: 'partners-programs-list',
		routeName: 'LIST_PARTNERS_PROGRAM',
		label: 'partnersPrograms',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PagePartnersProgram/lists/ListPartnersProgram/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_PARTNERS_POSTBACK: {
		path: 'partners-program-postback',
		routeName: 'LIST_PARTNERS_POSTBACK',
		label: 'partnersPostbacks',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PagePartnersProgram/lists/ListPartnersPostback/index.vue'
			),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	DETAIL_PARTNERS_PROGRAM: {
		path: 'partners-program-list/:id',
		routeName: 'DETAIL_PARTNERS_PROGRAM',
		label: 'partnersProgram',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PagePartnersProgram/detail/DetailPartnersProgram/index.vue'
			),
	},
	DETAIL_PARTNERS_POSTBACK: {
		path: 'partners-program-postback/:id',
		routeName: 'DETAIL_PARTNERS_POSTBACK',
		label: 'partnersPostback',
		role: ACCESS.AdminSysop,
		component: () =>
			import(
				'@/pages/PagePartnersProgram/detail/DetailPartnersPostback/index.vue'
			),
	},

	// ---SECTION CMS--- //
	PAGE_CMS: {
		path: '/cms',
		routeName: 'PAGE_CMS',
		label: 'cms',
		role: ACCESS.AdminSysopManager,
		iconName: 'cms',
	},
	// SUBSECTION IN CMS PAGE
	LIST_WIDGETS: {
		path: 'widgets-list',
		routeName: 'LIST_WIDGETS',
		label: 'widgets',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/lists/ListWidgets/index.vue'),
	},
	LIST_PROMO: {
		path: 'promo-slides-list',
		routeName: 'LIST_PROMO',
		label: 'promoSlidesList',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/lists/ListPromo/index.vue'),
		table: true,
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	LIST_NEWS: {
		path: 'news-list',
		routeName: 'LIST_NEWS',
		label: 'newsList',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/lists/ListNews/index.vue'),
	},
	LIST_TEXTS: {
		path: 'texts',
		routeName: 'LIST_TEXTS',
		label: 'textsList',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/lists/ListTexts/index.vue'),
	},
	// DETAIL PROMO PAGE
	DETAIL_PROMO: {
		path: 'main-promo-list/:id',
		routeName: 'DETAIL_PROMO',
		label: 'promoSlide',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/detail/DetailPromo/index.vue'),
	},
	// DETAIL NEWS PAGE
	DETAIL_NEWS: {
		path: 'news-list/:id',
		routeName: 'DETAIL_NEWS',
		label: 'news',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/detail/DetailNews/index.vue'),
	},
	// DETAIL TEXT PAGE
	DETAIL_TEXT: {
		path: 'text/:id',
		routeName: 'DETAIL_TEXT',
		label: 'text',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/detail/DetailText/index.vue'),
	},

	// ---SECTION CHAT--- //
	PAGE_CHAT: {
		path: '/chat',
		routeName: 'PAGE_CHAT',
		label: 'chat',
		role: ACCESS.AdminSysopSupport,
		iconName: 'chat-messages',
	},
	// SUBSECTION IN CHAT SECTION
	LIST_MESSAGES: {
		path: 'messages-list',
		routeName: 'LIST_MESSAGES',
		label: 'messagesList',
		role: ACCESS.AdminSysopSupport,
		component: () => import('@/pages/PageChat/lists/ListMessages/index.vue'),
	},
	BLACK_LIST: {
		path: 'blacklist',
		routeName: 'BLACK_LIST',
		label: 'blackList',
		role: ACCESS.AdminSysopSupport,
		component: () => import('@/pages/PageChat/lists/BlackList/index.vue'),
	},

	// ---SECTION BONUS--- //
	PAGE_BONUS: {
		path: '/bonuses',
		routeName: 'PAGE_BONUS',
		label: 'bonuses',
		role: ACCESS.AdminSysop,
		iconName: 'bonus',
	},
	// SUBSECTION IN BONUS SECTION
	LIST_LEVELS: {
		path: 'levels-list',
		routeName: 'LIST_LEVELS',
		label: 'levelsList',
		role: ACCESS.AdminSysop,
		component: () => import('@/pages/PageBonuses/lists/ListLevels/index.vue'),
	},
	LIST_BONUS_PRESETS: {
		path: 'presets-list',
		routeName: 'LIST_BONUS_PRESETS',
		label: 'presetsList',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/lists/ListBonusPresets/index.vue'),
	},
	LIST_CONFIG_CASHBACK: {
		path: 'config-cashback',
		routeName: 'LIST_CONFIG_CASHBACK',
		label: 'configCashback',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/lists/ListConfigCashback/index.vue'),
	},
	LIST_CONFIG_REFERRAL: {
		path: 'config-referral',
		routeName: 'LIST_CONFIG_REFERRAL',
		label: 'configReferrals',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/lists/ListConfigReferral/index.vue'),
	},
	LIST_CONFIG_DEPOSITS: {
		path: 'config-deposit',
		routeName: 'LIST_CONFIG_DEPOSITS',
		label: 'configDeposits',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/lists/ListConfigDeposits/index.vue'),
	},
	LIST_BONUSES: {
		path: 'list-bonuses',
		routeName: 'LIST_BONUSES',
		label: 'bonusesList',
		role: ACCESS.AdminSysop,
		component: () => import('@/pages/PageBonuses/lists/ListBonuses/index.vue'),
	},
	// DETAIL BONUS-PRESET PAGE
	DETAIL_BONUS_PRESET: {
		path: 'presets-list/:id',
		routeName: 'DETAIL_BONUS_PRESET',
		label: 'preset',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/detail/DetailBonusPreset/index.vue'),
	},
	// DETAIL CONFIG-DEPOSIT PAGE
	DETAIL_CONFIG_DEPOSIT: {
		path: 'config-deposit/:id',
		routeName: 'DETAIL_CONFIG_DEPOSIT',
		label: 'configDeposit',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/detail/DetailConfigDeposits/index.vue'),
	},

	// ---SECTION MISSIONS--- //
	PAGE_MISSIONS: {
		path: '/missions',
		routeName: 'PAGE_MISSIONS',
		label: 'missions',
		role: ACCESS.AdminSysop,
		iconName: 'missions',
	},
	// SUBSECTION IN MISSIONS PAGE
	LIST_MISSIONS: {
		path: 'missions-list',
		routeName: 'LIST_MISSIONS',
		label: 'missions',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageMissions/lists/ListMissions/index.vue'),
	},
	LIST_MISSIONS_PRESETS: {
		path: 'presets-list',
		routeName: 'LIST_MISSIONS_PRESETS',
		label: 'presetsList',
		role: ACCESS.AdminSysop,
		component: () => import('@/pages/PageMissions/lists/ListMissionsPresets'),
	},
	// DETAIL MISSION PAGE
	DETAIL_MISSION: {
		path: 'list-missions/:id',
		routeName: 'DETAIL_MISSION',
		label: 'mission',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageMissions/detail/DetailMission/index.vue'),
	},
	DETAIL_MISSION_PRESET: {
		path: 'presets-list/:id',
		routeName: 'DETAIL_MISSION_PRESET',
		label: 'preset',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageMissions/detail/DetailMissionPreset/index.vue'),
	},

	// ---SECTION TRANSLATIONS--- //
	PAGE_TRANSLATIONS: {
		path: '/translations',
		routeName: 'PAGE_TRANSLATIONS',
		label: 'translations',
		role: ACCESS.AdminSysopManager,
		iconName: 'world',
	},
	// SUBSECTION IN TRANSLATIONS PAGE
	LIST_LANGUAGES: {
		path: 'languages-list',
		routeName: 'LIST_LANGUAGES',
		label: 'languages',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageTranslations/list/ListLanguages/index.vue'),
	},
	LIST_DICTIONARY: {
		path: 'dictionary-list',
		routeName: 'LIST_DICTIONARY',
		label: 'dictionary',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageTranslations/list/ListDictionary/index.vue'),
	},

	PAGE_CATALOG: {
		path: '/catalog',
		routeName: 'PAGE_CATALOG',
		label: 'catalog',
		role: ACCESS.AdminSysopManager,
		iconName: 'catalog',
	},

	LIST_CURRENCY_CATALOG: {
		path: '/currency-catalog',
		routeName: 'LIST_CURRENCY_CATALOG',
		label: 'currencyCatalog',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import('@/pages/PageCatalog/list/ListCurrencyCatalog/index.vue'),
	},

	// ---CREATION PAGE--- //
	CREATE_PLAYER_BONUS: {
		path: 'create-player-bonus',
		routeName: 'CREATE_PLAYER_BONUS',
		label: 'addBonuses',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageUsers/create/CreatePlayerBonus/index.vue'),
	},
	CREATE_GAMES: {
		path: 'games-list/adding-games',
		routeName: 'CREATE_GAMES',
		label: 'addGames',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageGames/create/CreateGames/index.vue'),
	},
	CREATE_CATEGORY: {
		path: 'categories-list/create-category',
		routeName: 'CREATE_CATEGORY',
		label: 'createCategory',
		role: ACCESS.AdminSysopManager,
		component: () =>
			import('@/pages/PageGames/create/CreateCategory/index.vue'),
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	CREATE_TAG: {
		path: 'tags-list/create-tag',
		routeName: 'CREATE_TAG',
		label: 'createTag',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageGames/create/CreateTag/index.vue'),
		query: {
			...DEFAULT_TABLE_QUERY,
		},
	},
	CREATE_PROMO: {
		path: 'create-promo-slide',
		routeName: 'CREATE_PROMO',
		label: 'createPromoSlide',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/create/CreatePromo/index.vue'),
	},
	CREATE_NEWS: {
		path: 'create-news',
		routeName: 'CREATE_NEWS',
		label: 'createNews',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/create/CreateNews/index.vue'),
	},
	CREATE_TEXT: {
		path: 'create-text',
		routeName: 'CREATE_TEXT',
		label: 'createText',
		role: ACCESS.AdminSysopManager,
		component: () => import('@/pages/PageCms/create/CreateText/index.vue'),
	},
	CREATE_BONUS_PRESET: {
		path: 'presets-list/create-bonus-preset',
		routeName: 'CREATE_BONUS_PRESET',
		label: 'createPreset',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/create/CreateBonusPreset/index.vue'),
	},
	CREATE_CONFIG_DEPOSIT: {
		path: 'config-deposit/creating',
		routeName: 'CREATE_CONFIG_DEPOSIT',
		label: 'createConfigDeposits',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageBonuses/create/CreateConfigDeposits/index.vue'),
	},
	CREATE_MISSION_PRESET: {
		path: 'presets-list/create-mission-preset',
		routeName: 'CREATE_MISSION_PRESET',
		label: 'createPreset',
		role: ACCESS.AdminSysop,
		component: () =>
			import('@/pages/PageMissions/create/CreateMissionPreset/index.vue'),
	},
}
